import Opportunity from 'opportunities/Opportunity'
import OpportunitiesViewModel from './OpportunitiesViewModel'
import { computed, makeObservable } from 'mobx'
import Member from 'iam/models/Member'

export default class OpportunityViewModel {
  constructor(
    private opportunitiesVM: OpportunitiesViewModel,
    public opportunity: Opportunity,
  ) {
    makeObservable(this)
  }

  /**
   * The ID of the opportunity.
   */
  @computed
  get opportunityId() {
    return this.opportunity.id
  }

  /**
   * The current member for the opportunity's workspace.
   */
  @computed
  get currentMember() {
    return (
      this.opportunitiesVM.workspaceMemberships.find(
        (m) => m.workspace === this.opportunity.workspace,
      )?.member ?? Member.none
    )
  }

  /**
   * Whether selection is disabled.
   */
  @computed
  get disabled() {
    return this.opportunitiesVM.detailsVM.pickup.pending || !this.canPickUp
  }

  /**
   * Whether the current member is allowed to pick up the opportunity
   * as themselves.
   */
  @computed
  get canPickUpAsMyself() {
    return (
      this.currentMember.hasSomePermissions('JOB_PICKUP') &&
      !this.opportunity.isDispatchOpportunity
    )
  }

  /**
   * Teams that the user has pickup permissions in.
   */
  @computed
  get availableTeamsForPickingUp() {
    return this.opportunitiesVM
      .getTeamMembersInWorkspaceWhereUserHasSomePermissions(
        this.opportunity.workspace,
        ['JOB_PICKUP'],
      )
      .map((m) => m.team)
  }

  /**
   * Whether the current member is allowed to pick up the opportunity
   * given their job capacity in the workspace and the global capacity.
   */
  @computed
  get canPickUp() {
    return this.opportunitiesVM.canPickUpOpportunity(this.opportunity)
  }
}
